import '@babel/polyfill';
import Vue from 'vue';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import '@/assets/design-system/tokens.css';
import '@/assets/design-system/hublot.css';
import '@/assets/scss/design-system.scss';
import { applyActivity } from '@/plugins/theme';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/lib/locale/fr';
import './plugins/echarts';
import VueKeyCloak from '@dsb-norge/vue-keycloak-js';
import moment from 'moment';
// Configuration de vue-toastification
import Toast from "vue-toastification";
import router from '@/router';
import App from './App.vue';
import store from './store/store';
import "vue-toastification/dist/index.css";
import "@/assets/scss/toasts.scss";
import "@/plugins/toast.js";

const toastOptions = {
  position: "bottom-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  toastClassName: "custom-toast",
  bodyClassName: ["custom-toast-body"],
  transition: "Vue-Toastification__slideBlurred"
};

Vue.use(Toast, toastOptions);
Vue.use(Vuetify);

Vue.config.productionTip = false;
const opts = {
  // « Mobile » pour Vuetify (tiroir, onglets, $vuetify.breakpoint.mobile) : sous 960 px.
  // Le téléphone (moins de 600 px) est géré par MobileMixin et les règles du design system.
  breakpoint: { mobileBreakpoint: 960 },
  lang: {
    locales: { fr },
    current: 'fr',
  },
  icons: {
    iconfont: 'mdi',  // Changé de 'md' à 'mdi'
    values: {
      files: 'folder_copy',
      file: 'description',
      file_multiple: 'library_books',
      document: 'article',
      folder_files: 'folder_open',
      file_present: 'attach_file',
      fiber_manual_record: 'circle',
    },
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#376374',
        secondary: '#8AC3D5',
        fish: '#3B6A87',
        conditionnement: '#263238',
        taille: '#A54D3A',
        preparation: '#B97C1A',
        qualite: '#BF360C',
        origin: '#3D7B6A',
        label: '#00796B',
      },
      // Mêmes couleurs métier en sombre ; les tokens les réalignent au démarrage (plugins/theme.js).
      // Conditionnement s'éclaircit : #263238 se confondrait avec le fond sombre, le texte blanc reste à 5:1.
      dark: {
        primary: '#376374',
        secondary: '#8AC3D5',
        fish: '#3B6A87',
        conditionnement: '#546E7A',
        taille: '#A54D3A',
        preparation: '#B97C1A',
        qualite: '#BF360C',
        origin: '#3D7B6A',
        label: '#00796B',
      },
    },
  },
};
moment.locale('fr');

// eslint-disable-next-line
// Vue.config.devtools = process.env.NODE_ENV === "development";

Vue.use(VueKeyCloak, {
  config: {
    clientId: 'front',
    realm: 'crm',
    url: 'https://keycloak.hublot.io',
  },
  init: { onLoad: 'login-required', checkLoginIframe: false },
  onReady: () => {
    // Initialise le contexte app (hublot par défaut)
    store.dispatch('setApp', store.state.home.app)
      .then(() => store.dispatch('loadUserProfile'))
      .then(() => {
        const vuetify = new Vuetify(opts)
        // Métier (Poissonnerie / Boucherie) : attribut data-activity sur <html> + thème Vuetify
        applyActivity(vuetify.framework, store.state.home.app)
        const app = new Vue({
          router,
          store,
          vuetify,
          render: h => h(App),
        }).$mount('#app')
        // Debug: expose keycloak + store dans la console (window.$kc / window.$store)
        window.$kc = app.$keycloak
        window.$store = store
      })
  },
})

